"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.RelationType = exports.Action = exports.RelationMemberStatus = exports.RelationPermissionType = void 0;
var RelationPermissionType;
(function (RelationPermissionType) {
    RelationPermissionType["PRIMARY"] = "PRIMARY";
    RelationPermissionType["SPOUSE"] = "SPOUSE";
    RelationPermissionType["DEPENDENT"] = "DEPENDENT";
    RelationPermissionType["NORMAL_USER"] = "NORMAL_USER";
    RelationPermissionType["OWNER"] = "OWNER";
    RelationPermissionType["CO_OWNER"] = "CO_OWNER";
    RelationPermissionType["SECONDARY"] = "SECONDARY";
    RelationPermissionType["TERTIARY"] = "TERTIARY";
    RelationPermissionType["ELDER"] = "ELDER";
})(RelationPermissionType = exports.RelationPermissionType || (exports.RelationPermissionType = {}));
var RelationMemberStatus;
(function (RelationMemberStatus) {
    RelationMemberStatus["Inactive"] = "Inactive";
    RelationMemberStatus["Active"] = "Active";
})(RelationMemberStatus = exports.RelationMemberStatus || (exports.RelationMemberStatus = {}));
var Action;
(function (Action) {
    Action["CREATED"] = "CREATED";
    Action["UPDATED_TYPE"] = "UPDATED_TYPE";
    Action["UPDATED_ALIAS"] = "UPDATED_ALIAS";
    Action["REMOVED"] = "REMOVED";
    Action["ADDED_MEMBER"] = "ADDED_MEMBER";
    Action["ADDED_MEMBERS"] = "ADDED_MEMBERS";
    Action["REMOVED_MEMBER"] = "REMOVED_MEMBER";
    Action["UPDATED_MEMBER"] = "UPDATED_MEMBER";
    Action["UPDATED_PRIMARY_MEMBER"] = "UPDATED_PRIMARY_MEMBER";
})(Action = exports.Action || (exports.Action = {}));
var RelationType;
(function (RelationType) {
    RelationType["Family"] = "Family";
    RelationType["Business"] = "Business";
    RelationType["Associate"] = "Associate";
})(RelationType = exports.RelationType || (exports.RelationType = {}));
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../utils");
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://relations.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Relations API
 * @version v1
 * @baseUrl https://relations.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags RelationMembers
             * @name RelationMembersFetchMembers
             * @request GET:/v1/identities/{identityId}/relations/{relationId}/members
             * @secure
             */
            relationMembersFetchMembers: (identityId, relationId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/relations/${relationId}/members`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags RelationMembers
             * @name RelationMembersBulkAddMembers
             * @request POST:/v1/identities/{identityId}/relations/{relationId}/bulkAddMembers
             * @secure
             */
            relationMembersBulkAddMembers: (identityId, relationId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/relations/${relationId}/bulkAddMembers`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags RelationMembers
             * @name RelationMembersAddMember
             * @request POST:/v1/identities/{identityId}/relations/{relationId}/addMember
             * @secure
             */
            relationMembersAddMember: (identityId, relationId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/relations/${relationId}/addMember`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags RelationMembers
             * @name RelationMembersRemoveMember
             * @request POST:/v1/identities/{identityId}/relations/{relationId}/removeMember
             * @secure
             */
            relationMembersRemoveMember: (identityId, relationId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/relations/${relationId}/removeMember`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags RelationMembers
             * @name RelationMembersUpdateMember
             * @request POST:/v1/identities/{identityId}/relations/{relationId}/updateMember
             * @secure
             */
            relationMembersUpdateMember: (identityId, relationId, query, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/relations/${relationId}/updateMember`, method: 'POST', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags RelationMembers
             * @name RelationMembersUpdatePrimaryMember
             * @request POST:/v1/identities/{identityId}/relations/{relationId}/updatePrimaryMember
             * @secure
             */
            relationMembersUpdatePrimaryMember: (identityId, relationId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/relations/${relationId}/updatePrimaryMember`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Relations
             * @name RelationsCreateRelation
             * @request POST:/v1/identities/{identityId}/relations
             * @secure
             */
            relationsCreateRelation: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/relations`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Relations
             * @name RelationsFetchRelations
             * @request GET:/v1/identities/{identityId}/relations
             * @secure
             */
            relationsFetchRelations: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/relations`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Relations
             * @name RelationsFetchRelation
             * @request GET:/v1/identities/{identityId}/relations/{relationId}
             * @secure
             */
            relationsFetchRelation: (identityId, relationId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/relations/${relationId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Relations
             * @name RelationsUpdateType
             * @request POST:/v1/identities/{identityId}/relations/{relationId}/updateType
             * @secure
             */
            relationsUpdateType: (identityId, relationId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/relations/${relationId}/updateType`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Relations
             * @name RelationsUpdateAlias
             * @request POST:/v1/identities/{identityId}/relations/{relationId}/updateAlias
             * @secure
             */
            relationsUpdateAlias: (identityId, relationId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/relations/${relationId}/updateAlias`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Relations
             * @name RelationsRemoveRelation
             * @request POST:/v1/identities/{identityId}/relations/{relationId}/removeRelation
             * @secure
             */
            relationsRemoveRelation: (identityId, relationId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/relations/${relationId}/removeRelation`, method: 'POST', secure: true }, params)),
            /**
             * No description
             *
             * @tags Relations
             * @name RelationsChangeOwner
             * @request POST:/v1/identities/{identityId}/relations/{relationId}/changeOwner
             * @secure
             */
            relationsChangeOwner: (identityId, relationId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/relations/${relationId}/changeOwner`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;
//# sourceMappingURL=relations.js.map